export interface SaveStatus {
  pending: number;
  failedCount: number;
  justSaved: boolean;
}

export function SaveStatusChip({
  status,
  onRetry,
}: {
  status: SaveStatus;
  onRetry: () => void;
}) {
  if (status.failedCount > 0) {
    return (
      <span className="save-chip save-chip-error">
        {status.failedCount} {status.failedCount === 1 ? "save" : "saves"} failed
        <button type="button" className="save-chip-retry" onClick={onRetry}>
          Retry
        </button>
      </span>
    );
  }
  if (status.pending > 0) {
    return <span className="save-chip save-chip-saving">Saving…</span>;
  }
  if (status.justSaved) {
    return <span className="save-chip save-chip-saved">Saved</span>;
  }
  return null;
}
